
// CLICK (works always)
document.addEventListener("click", function (e) {
  const title = e.target.closest('.filterBox .widget-title');

  if (title) {
    const box = title.closest('.filterBox');
    box.classList.toggle('active');
  }
});

// AUTO OPEN AFTER LOAD / AJAX
function autoOpenFilters() {
  document.querySelectorAll('.filterBox').forEach(box => {
    if (box.querySelector('input:checked')) {
      box.classList.add('active');
    }
  });
}
document.addEventListener("DOMContentLoaded", autoOpenFilters);
document.addEventListener("shopify:section:load", autoOpenFilters);





// document.addEventListener("DOMContentLoaded", function () {

//   const oldSelect = document.querySelector("#SortBySt");

//   if (!oldSelect) return;

//   const newSelect = oldSelect.cloneNode(true);

//   oldSelect.parentNode.replaceChild(newSelect, oldSelect);

//   newSelect.addEventListener("change", function (e) {

//     e.preventDefault();

//     const value = this.value;

//     if (value.includes("new_discount_tage")) {

//       const newUrl =
//         window.location.pathname +
//         "?filter.p.m.custom.new_discount_tage=1";

//       history.pushState({}, "", newUrl);

//       fetch(newUrl)
//         .then((response) => response.text())
//         .then((html) => {

//           const parser = new DOMParser();
//           const doc = parser.parseFromString(html, "text/html");

//           const newProducts = doc.querySelector(".grid-products");
//           const currentProducts = document.querySelector(".grid-products");

//           if (newProducts && currentProducts) {
//             currentProducts.innerHTML = newProducts.innerHTML;
//           }

//         });

//     }

//   });

// });



document.addEventListener("DOMContentLoaded", function () {

  const oldSelect = document.querySelector("#SortBySt");

  if (!oldSelect) return;

  const newSelect = oldSelect.cloneNode(true);

  oldSelect.parentNode.replaceChild(newSelect, oldSelect);

  newSelect.addEventListener("change", function () {

    const value = this.value;

    if (value.includes("new_discount_tage")) {

      const currentUrl = new URL(window.location.href);

      currentUrl.searchParams.set(
        "filter.p.m.custom.new_discount_tage",
        "1"
      );

      history.pushState({}, "", currentUrl.toString());

      fetch(currentUrl.toString())
        .then((response) => response.text())
        .then((html) => {

          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const newProducts = doc.querySelector(".grid-products");
          const currentProducts = document.querySelector(".grid-products");

          if (newProducts && currentProducts) {
            currentProducts.innerHTML = newProducts.innerHTML;
          }

        });

    }

  });

});